import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { constants } from 'src/app/utils/constants';
import { Checklist } from 'src/app/models/checklist.model';
import { Organisation } from 'src/app/models/organisation.model';
import { CommonService } from 'src/app/services/common.service';
import { map, Observable, startWith } from 'rxjs';
import * as states from 'src/app/utils/states.json';

@Component({
  selector: 'app-organisation',
  templateUrl: './organisation.component.html',
  styleUrls: ['./organisation.component.scss'],
  standalone: false
})
export class OrganisationComponent  implements OnInit {

  public accessibleMode: string = '';
  public itemId: string = '';
  public typeList: any[] = [];
  public subTypeList: any[] = [];
  public selectionList: any[] = [];
  public entityTypeList: any[] = [];
  public subEntityTypeList: any[] = [];
  public organisationForm: FormGroup;

  public organisationInfo: Organisation = {
    type: constants.AFL,
    subType: null,
    entityType: constants.EMPTY,
    entityTypeName: null,
    subEntityType: constants.EMPTY,
    subEntityName: null,
    inspectionDateTime: null,
    state: null,
  };

  public associationList: string[] = [];
  public clubNamesList: string[] =[];

  public filteredOptionsAssoc: Observable<string[] | any>;
  public filteredOptionsClub: Observable<string[]|any>;

  public isValid: boolean = false;
  public stateList: any[] = (states as any).default;


  constructor(
    private formBuilder: FormBuilder,
    private navController: NavController,
    private router: Router,
    private commonService: CommonService
  ) {
    this.organisationForm = this.formBuilder.group({
      type: new FormControl({ value: constants.AFL, disabled: true }),
      subType: new FormControl(constants.EMPTY, Validators.required),
      entityType: new FormControl({ value: constants.ASSOCIATION, disabled: true }),
      entityTypeName: new FormControl({ value: constants.EMPTY, disabled: true }, [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC_SPECIAL_CHARS)]),
      subEntityType: new FormControl({ value: constants.CLUB, disabled: true }),
      subEntityName: new FormControl({ value: constants.EMPTY, disabled: true }, [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC_SPECIAL_CHARS)]),
      inspectionDateTime: new FormControl('', Validators.required),
      state: new FormControl({ value: constants.EMPTY, disabled: true }, Validators.required)
    });

    this.filteredOptionsAssoc = this.organisationForm.get('entityTypeName')!.valueChanges.pipe(
      startWith(''),
      map(value => {
        return (value.length >= 3) ? this.filterAssociation(value) : this.associationList.slice();
      }),
    );

    this.filteredOptionsClub = this.organisationForm.get('subEntityName')!.valueChanges.pipe(
      startWith(''),
      map(value => {
        return (value.length >= 3) ? this.filterClubs(value) : this.clubNamesList.slice();      
      }),
    );
  }

  ngOnInit() {
    this.initializeApp();
    this.fieldChanges();
    this.commonService.pushCurrentTabPosition(1);
    this.filterMonitoring();
  }

  private initializeApp() {
    this.commonService.pushCurrentTabPosition(1);
    this.subTypeList = [...this.commonService.getSelectedItem('ACTIVITY')];
    this.entityTypeList = [...this.commonService.getSelectedItem('ENTITY_TYPE')];
    this.subEntityTypeList = [...this.commonService.getSelectedItem('ENTITY_SUBTYPE')];
    this.initializeForm();
  }

  public async initializeForm() {
    if (this.router?.getCurrentNavigation()?.extras?.state?.['queryParams'].itemId) {
      this.accessibleMode = this.router?.getCurrentNavigation()?.extras?.state?.['queryParams'].accessibleMode;
      this.itemId = this.router?.getCurrentNavigation()?.extras?.state?.['queryParams'].itemId;
      const checklist: Checklist = await this.commonService.getItem(this.itemId);
      
      if ((this.accessibleMode === 'VIEW' || this.accessibleMode === 'EDIT') && checklist.organisation != null) {
        console.log(this.accessibleMode);
        this.commonService.setCurrentMode(this.accessibleMode, checklist);
        this.organisationInfo = checklist.organisation;
        const selectedState = (this.accessibleMode === 'VIEW') ? this.stateList.find(x=>x.stateCode==this.organisationInfo?.state).stateName : this.organisationInfo?.state;
        this.organisationForm = this.formBuilder.group({
          type: new FormControl({ value: this.organisationInfo.type, disabled: true }),
          subType: new FormControl(this.organisationInfo?.subType, Validators.required),
          entityType: new FormControl(this.organisationInfo?.entityType, Validators.required),
          entityTypeName: new FormControl( this.organisationInfo?.entityTypeName, [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC_SPECIAL_CHARS)]),
          subEntityType: new FormControl(this.organisationInfo?.subEntityType),
          subEntityName: new FormControl(this.organisationInfo?.subEntityName, [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC_SPECIAL_CHARS)]),
          inspectionDateTime: new FormControl(this.organisationInfo?.inspectionDateTime, Validators.required),
          state: new FormControl(selectedState, Validators.required)
        });
      }
      this.fieldChanges();
      this.filterMonitoring();
    } else {
      this.navController.navigateForward(constants.PAGE.CHECKLIST);
    }
  }

  public filterMonitoring() {
    this.filteredOptionsAssoc = this.organisationForm.get('entityTypeName')!.valueChanges.pipe(
      startWith(''),
      map(value => {
        return (value.length >= 3) ? this.filterAssociation(value) : this.associationList.slice();
      }),
    );

    this.filteredOptionsClub = this.organisationForm.get('subEntityName')!.valueChanges.pipe(
      startWith(''),
      map(value => {
        return (value.length >= 3) ? this.filterClubs(value) : this.clubNamesList.slice();      
      }),
    );
  }

  public async backToPage() {
    this.commonService.pushCurrentTabPosition(0);
    await this.navController.navigateBack(constants.PAGE.CHECKLIST, { replaceUrl: true })
      .then(async() => {
        await this.commonService.clearAllLocalstorage();
        //location.reload();
      });
    }

  public async nextPage() {
    if (this.validateForm()) {
      console.log(this.organisationForm.errors);
      return;
    }

    this.commonService.pushCurrentTabPosition(2);
    this.organisationInfo.type = this.organisationForm.get('type')?.value;
    this.organisationInfo.subType  = this.organisationForm.get('subType')?.value;
    this.organisationInfo.entityType = constants.ASSOCIATION;
    this.organisationInfo.entityTypeName = this.organisationForm.get('entityTypeName')?.value;
    this.organisationInfo.subEntityType = constants.CLUB;
    this.organisationInfo.subEntityName = this.organisationForm.get('subEntityName')?.value;
    this.organisationInfo.inspectionDateTime = this.organisationForm.get('inspectionDateTime')?.value;
    this.organisationInfo.state = this.organisationForm.get('state')?.value;

    const navigationExtras: NavigationExtras = {
      state: {
        queryParams: {
          accessibleMode: this.accessibleMode,
          itemId: this.itemId
        }
      }
    };

    if (this.accessibleMode === constants.VIEW) {
      await this.navController.navigateForward(constants.PAGE.ADDRESS, navigationExtras);
    }
    else if (this.accessibleMode === constants.NEW || this.accessibleMode === constants.EDIT) {
      const returnItemId: string = await this.commonService.insertChecklistItem(this.itemId, constants.ORGANISATION, this.organisationInfo);
      if (this.itemId === returnItemId) {
        await this.navController.navigateForward(constants.PAGE.ADDRESS, navigationExtras);
      }
    }
    else {
      await this.navController.navigateBack(constants.PAGE.CHECKLIST, { replaceUrl: true });
    }
  }

  public validateForm() {
    const controls = this.organisationForm.controls;
    this.organisationForm.markAllAsTouched();
    for (const controlName in controls) {
      if (controls[controlName].invalid) {
        console.log(controlName);
        const element = document.getElementById(controlName);
        if (element) {
          alert
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => {
            element.focus();
          }, 300);
        }
        return true;
      }
    }
    return false;
  }

  private filterAssociation(inputValue: string): string[] {
    var stateCode = this.organisationForm.get('state')?.value;
    return this.associationList = this.commonService.getFilteredAssocAndClubList('ASSO',stateCode,inputValue); //ASSO use for Association 
  }

  private filterClubs(inputValue: string): string[] {
    var stateCode = this.organisationForm.get('state')?.value;
    var associationVal = this.organisationForm.get('entityTypeName')?.value;
    return this.clubNamesList = this.commonService.getFilteredAssocAndClubList('CLUB',stateCode,inputValue,associationVal);//CLUB use for club 
  }

  public fieldChanges() {
    this.organisationForm.get('subType')?.valueChanges.subscribe(value => {
      if (value || this.organisationForm.get('subType')?.value) {
        this.organisationForm.get('state')?.enable();
        this.organisationForm.get('state')?.setValue(constants.EMPTY);
      } else {
        this.organisationForm.get('state')?.disable();
        this.organisationForm.get('entityTypeName')?.disable();
        this.organisationForm.get('subEntityName')?.disable();
      }
    });

    this.organisationForm.get('state')?.valueChanges.subscribe(value => {
      if (value) {
        this.organisationForm.get('entityTypeName')?.enable();
        this.organisationForm.get('entityTypeName')?.setValue(constants.EMPTY);
      } else {
        this.organisationForm.get('entityTypeName')?.disable();
        this.organisationForm.get('subEntityName')?.disable();
      }
    });

    this.organisationForm.get('entityTypeName')?.valueChanges.subscribe(value => {
      if (value) {
        this.organisationForm.get('subEntityName')?.enable();
      } else {
        this.organisationForm.get('subEntityName')?.disable();
        this.organisationForm.get('subEntityName')?.setValue(constants.EMPTY);
      }
    });
  }

}
